import IsoDownload from 'icons/indexed-icons/IsoDownload';
import OmniBlue from 'icons/indexed-icons/OmniBlue';
import {
  Container,
  HeadingBox,
  LogoBox,
  Main,
  ListBox,
  CloseBox,
  DownloadIconBox,
  AddtoHomeBox,
  Overlay
} from './index.elements';
import XcloseIcon from 'icons/indexed-icons/XcloseIcon';

interface PopupProps {
  onClose: (status: boolean) => void;
}

const AppDownloadPopup: React.FC<PopupProps> = ({ onClose }) => {
  const baseClass = 'app-download-popup';

  return (
    <>
      <Overlay className={`${baseClass}__overlay`}></Overlay>
      <Container className={`${baseClass}__container`}>
        <HeadingBox className={`${baseClass}__heading`}>
          <LogoBox className={`${baseClass}__logo`}>
            <OmniBlue />
          </LogoBox>
          <p>Install OmniBlu</p>
        </HeadingBox>
        <Main className={`${baseClass}__main`}>
          <p className={`${baseClass}__desciption`}>
            Install the app on your device to easily access it anytime. No app store. No download.
            No hassle.
          </p>
          <ListBox className={`${baseClass}__installation-steps`}>
            <CloseBox onClick={() => onClose(false)}>
              {/* <img src={CloseLogo} alt="close" /> */}
              <XcloseIcon/>
            </CloseBox>
            <div className={`${baseClass}__step-1`}>
              <p>1. Tap on</p>
              <DownloadIconBox className={`${baseClass}__download-icon-box`}>
                <IsoDownload />
              </DownloadIconBox>
            </div>
            <div className={`${baseClass}__step-2`}>
              <p>2. Select</p>
              <AddtoHomeBox className={`${baseClass}__addtohome-box`}>
                <p>Add to Home Screen</p>
              </AddtoHomeBox>
            </div>
          </ListBox>
        </Main>
      </Container>
    </>
  );
};

export default AppDownloadPopup;
